{
  "#UMSATZSTATISTIK": {
    "TITLE": "Umsatzstatistik",
    "PAGES": {
      "QUERY": {
        "HEADER": "Umsatzstatistik",
        "RESET": "Zurücksetzen",
        "SUBMIT": "Abfragen",
        "FORM": {
          "FROM": "Von",
          "TO": "Bis",
          "EBENE": "Ebene",
          "AUFGLIEDERUNG": "Aufgliederung",
          "UMSATZART": "Umsatzart",
          "VKFORG": "Filiale",
          "ARTIKEL": "Artikel"
        }
      },
      "RESULT": {
        "TITLE": "Ergebnis",
        "SECTIONS": {
          "STATISTIK": "Statistik"
        },
        "TABS": {
          "TABLE": "Tabelle",
          "DIAGRAM": "Diagramm"
        },
        "DIAGRAM": {
          "LEGEND": {
            "NETTO": "Netto",
            "NETTO_VGL": "Netto Vorjahr",
            "DB": "DB (Rohertrag)",
            "DB_VGL": "DB Vorjahr"
          }
        },
        "TABLE": {
          "HEADER": {
            "UMSATZ": "Umsatz",
            "LAGERWERT": "Lagerwert",
            "ROHERTRAG": "DB",
            "DB_PROZ": "DB%",
            "UMSATZ_VJ": "Umsatz Vorj.",
            "LAGERWERT_VJ": "Lagerwert Vorj.",
            "ROHERTRAG_VJ": "DB Vorjahr",
            "DB_PROZ_VJ": "DB% Vorjahr",
            "ACTION": "Aktion"
          },
          "SUMME": "Summe"
        },
        "TABLE_BELEG": {
          "HEADER": {
            "FILIALE": "Filiale",
            "BELEGART": "Belegart",
            "L_KU_NR": "L-KuNr",
            "L_KUNDEN_BEZ": "L-Kudenbezeichnung",
            "RE_KU_NR": "Re-KuNr",
            "RE_KUNDEN_BEZ": "Re-Kudenbezeichnung",
            "RECHNUNG_NR": "RechnungNr",
            "BELEGDATUM": "Belegdatum",
            "WERT": "Wert",
            "DB": "DB",
            "DB_PROZ": "DB%",
            "ANWENDER": "Anwender",
            "ERFZEIT": "Erfzeit",
            "WES": "WES"
          },
          "SUMME": "Summe"
        }
      }
    },
    "COMPONENTS": {
      "COMPACT_CHART": {
        "NETTO": "Netto",
        "DB": "DB (Rohertrag)",
        "NETTO_VGL": "Netto Vergleichszeitraum"
      }
    },
    "DIALOGS": {
      "EDIT_DATE": {
        "TITLE": "Datum ändern",
        "CANCEL": "Abbrechen",
        "SAVE": "Speichern"
      },
      "EDIT_FOK":{
        "TITLE": "Filter anpassen",
        "CANCEL": "Abbrechen",
        "SAVE": "Speichern"
      },
      "EDIT_SELECT":{
        "TITLE": "Filter anpassen",
        "CANCEL": "Abbrechen",
        "SAVE": "Speichern"
      },
      "EDIT_TOGGLE_SWITCH":{
        "TITLE": "Filter anpassen",
        "CANCEL": "Abbrechen",
        "SAVE": "Speichern"
      }
    }
  }
}
